class SelectController {
  constructor(EventEmitter, $scope, $window) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.scope = $scope;
    this.isMobileApp = $window.innerWidth < 1024;
    this.cleanSelectedValue();
  }

  $onInit() {
    if (this.initialValue && this.options && this.options.length > 0) {
      this.selectedValue = this.initialValue;
    }

    this.scope.$watch(() => this.initialValue, (value) => { this.selectedValue = value; });
  }

  removeInputSearch() {
    let inputsSearch = angular.element('.ui-select-search').first();
    inputsSearch.remove();
    this.removeInputSelectFocusser();
  }
  
  removeInputSelectFocusser() {
    let inputsSearch = angular.element('.ui-select-focusser').first();
    inputsSearch.remove();
  }

  select(item, model) {
    this.onSelect(this.EventEmitter({ $item: item, $model: model }));
  }

  cleanSelectedValue() {
    this.scope.$watch(() => this.options, (newValue) => {
      if (newValue && newValue.length === 0) {
        this.selectedValue = undefined;
      }
    });
  }

  getClasses() {
    return {
      'responsiveMobile': this.isMobileApp,
      'two-lines': (this.isMobileApp && this.inTwoLines)
    };
  }
}

export default SelectController;



// WEBPACK FOOTER //
// ./client/app/components/select/select.controller.js